import Button from "@mui/material/Button";
import qrimg from "../../assets/qr-2-remove.png";
import { useState } from "react";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { useSnackbar } from "../../context/SnackBarContext";
import { useQrAuth } from "../../context/QrAuth";
import { validateEmail } from "../../validations/validate";
import fetcher from "../../helper/fetcher";

export default function QrLoginScreen() {
  const navigate = useNavigate()
  const { showSuccess, showError } = useSnackbar();
  const [showPassword, setShowPassword] = useState(false)
  const { setIsAuthenticated, setUser: Log, setRoles } = useQrAuth()
  const [user, setUser] = useState({
    email: '',
    password: '',
    isLoading: false
  })

  // const validatePassword = (password) => {
  //   const requirements = [
  //     { test: (p) => p.length >= 6, message: "Password must contain at least 6 characters" },
  //     { test: (p) => /[0-9]/.test(p), message: "Password must contain at least one number" },
  //     { test: (p) => /[a-z]/.test(p), message: "Password must contain one lower case character" },
  //     { test: (p) => /[A-Z]/.test(p), message: "Password must contain one upper case character" },
  //     { test: (p) => /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(p), message: "Password must contain one special character" }
  //   ];

  //   for (const { test, message } of requirements) {
  //     if (!test(password)) {
  //       return showError(message);
  //     }
  //   }
  //   return true;
  // };

  const updateState = (data) => {
    setUser((prevState) => {
      const newState = { ...prevState, ...data }
      return newState
    })
  }

  const handleLogin = async (e) => {
    e.preventDefault()
    localStorage.clear();
    if (!validateEmail(user.email)) {
      return showError("Enter valid email")
    } else {
      updateState({ isLoading: true })
      fetcher.post("/qr/auth/login", {
        email: user.email,
        password: user.password
      })
        .then((res) => {
          Log(res.data.data)
          localStorage.setItem("token", JSON.stringify(res.data?.jwt))
          showSuccess('Login successfully!');
          navigate(`/contact-card/dashboard/${res.data?.data?.index}`)
          setIsAuthenticated(true)
        })
        .catch((error) => {
          showError(error.response?.data?.message || "Internal server Error");
        }).finally(() => {
          updateState({ isLoading: false })
        })
    }
  }

  return (
    <div className="grid md:grid-cols-2 min-h-screen items-center justify-center bg-white">
      <div className="hidden md:flex flex-col items-center justify-center h-full bg-gradient-to-br from-[#bf98ce] to-[rgb(143,119,198)]">
        <img src={qrimg} alt="Create Account" className="" />
      </div>

      <div className="px-20 bg-white pb-10 ">
        <h2 className="text-[30px] font-bold text-[rgb(143,119,198)] mb-6">Log in</h2>
        <div className="space-y-5">
          <div >
            <label className="block text-sm font-semibold mb-1">Email Address</label>
            <input
              type="text"
              placeholder="Email"
              name="email"
              className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#756c94]"
              value={user.email}
              onChange={(e) => setUser((pre) => ({ ...pre, email: e.target.value }))}
            />
          </div>

          <div >
            <label className="block text-sm font-semibold mb-1">Password</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                name="password"
                className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#756c94] pr-10"
                value={user.password}
                onChange={(e) => setUser((pre) => ({ ...pre, password: e.target.value }))}
              />
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                className="absolute inset-y-0 right-3 flex items-center text-gray-500"
              >
                {showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
              </button>
            </div>
          </div>
        </div>
        <div className="text-right mt-2">
          <Link to="/contact-card/reset-password" className="text-black hover:underline">
            Forget password?
          </Link>
        </div>
        <div className="mt-6">
          <Button
            onClick={handleLogin}
            className="!bg-[#8f77c6] !text-white  w-full"
          >
            Login
          </Button>
        </div>
        <Link
          to="/contact-card/create-account"
          className="block text-sm font-semibold mb-1 text-center mt-10"
        >
          Don’t have an account?{" "}
          <span className="text-[#8f77c6]">Sign up</span>
        </Link>


      </div>
    </div>
  );
}
